
import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import ToastElement from "../../../components/toast";
import CanteenService from "../../../services/canteen-service";
import {
    addPriceRuleError,
    addPriceRuleSuccess,
    assignTenantsError,
    assignTenantsSuccess,
    deletePriceRuleError,
    deletePriceRuleSuccess,
    getCategoriesByGuestDiscountError,
    getCategoriesByGuestDiscountSuccess,
    getGuestDiscountsByCategoryError,
    getGuestDiscountsByCategorySuccess,
    getPriceRuleDetailsError,
    getPriceRuleDetailsSuccess,
    getPriceRuleError,
    getPriceRuleSuccess
} from "../action";
import {
    ADD_PRICE_RULE,
    ASSIGN_TENANTS,
    DELETE_PRICE_RULE,
    GET_CATEGORIES_BY_GUEST_DISCOUNT,
    GET_GUEST_DISCOUNTS_BY_CATEGORY,
    GET_PRICE_RULE_DETAILS,
    GET_PRICE_RULES
} from "../types";


export function* watchGetPriceRule() {
    yield takeEvery(GET_PRICE_RULES, getPriceRuleAc);
}

const getPriceRuleAsync = async (canteenId) => {
    return CanteenService.getPriceRules(canteenId);
};

function* getPriceRuleAc({ payload }) {
    try {
        const response = yield call(getPriceRuleAsync, payload.canteenId);
        if (response.data.success) {
            yield put(getPriceRuleSuccess(response.data.data));
        } else {
            yield put(getPriceRuleError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(getPriceRuleError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}


export function* watchAddPriceRule() {
    yield takeEvery(ADD_PRICE_RULE, addPriceRule);
}

const addPriceRuleAsync = async (data, priceRuleId) => {
    return CanteenService.addPriceRule(data, priceRuleId);
};

function* addPriceRule({ payload }) {
    try {
        const response = yield call(addPriceRuleAsync, payload.priceRuleData, payload.priceRuleId);
        if (response.data.success) {
            payload?.callback?.()
            yield put(addPriceRuleSuccess(response.data.success, response.data.message));
        } else {
            yield put(addPriceRuleError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(addPriceRuleError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}


export function* watchAssignTenants() {
    yield takeEvery(ASSIGN_TENANTS, assignTenants);
}

const assignTenantsAsync = async (data) => {
    return CanteenService.assignTenants(data.priceRuleId, data.tenants);
};

function* assignTenants({ payload }) {
    try {
        const response = yield call(assignTenantsAsync, payload);
        if (response.data.success) {
            payload?.callback?.()
            const tenants = response?.data?.data?.assignedTenants ?? []
            yield put(assignTenantsSuccess(response.data.success, response.data.message, tenants, payload.priceRuleId));
        } else {
            yield put(assignTenantsError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(assignTenantsError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}



export function* watchGetPriceRuleDetails() {
    yield takeEvery(GET_PRICE_RULE_DETAILS, getPriceRuleDetails);
}

const getPriceRuleDetailsAsync = async (priceRuleId) => {
    return CanteenService.getPriceRuleDetails(priceRuleId);
};

function* getPriceRuleDetails({ payload }) {
    try {
        const response = yield call(getPriceRuleDetailsAsync, payload.priceRuleId);
        if (response.data.success) {
            yield put(getPriceRuleDetailsSuccess(response.data.data));
        } else {
            yield put(getPriceRuleDetailsError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(getPriceRuleDetailsError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}



export function* watchDeletePriceRule() {
    yield takeEvery(DELETE_PRICE_RULE, deletePriceRule);
}

const deletePriceRuleAsync = async (id) => {
    return CanteenService.deletePriceRule(id);
};

function* deletePriceRule({ payload }) {
    try {
        const response = yield call(deletePriceRuleAsync, payload.priceRuleId);
        if (response.data.success) {
            payload?.callback?.()
            toast.success(
                <ToastElement type="success" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
            yield put(
                deletePriceRuleSuccess(response.data.success, response.data.message, payload.priceRuleId)
            );
            // yield put(getPriceRule(payload.canteenId));
        } else {
            yield put(deletePriceRuleError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(deletePriceRuleError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}


export function* watchGetGuestDiscountsByCategory() {
    yield takeEvery(GET_GUEST_DISCOUNTS_BY_CATEGORY, getGuestDiscountsByCategoryAc);
}

const getGuestDiscountsByCategoryAsync = async (canteenId) => {
    return CanteenService.getGuestDiscountsByCategory(canteenId);
};

function* getGuestDiscountsByCategoryAc({ payload }) {
    try {
        const response = yield call(getGuestDiscountsByCategoryAsync, payload.canteenId);
        if (response.data.success) {
            yield put(getGuestDiscountsByCategorySuccess(response.data.data));
        } else {
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
            yield put(getGuestDiscountsByCategoryError(response.data.message));
        }
    } catch (error) {
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
        yield put(getGuestDiscountsByCategoryError(error.response.data.message));
    }
}


export function* watchGetCategoriesByGuestDiscount() {
    yield takeEvery(GET_CATEGORIES_BY_GUEST_DISCOUNT, getCategoriesByGuestDiscountAc);
}
const getCategoriesByGuestDiscountAsync = async (canteenId) => {
    return CanteenService.getCategoriesByGuestDiscount(canteenId);
};


function* getCategoriesByGuestDiscountAc({ payload }) {
    try {
        const response = yield call(getCategoriesByGuestDiscountAsync, payload.canteenId);
        if (response.data.success) {
            yield put(getCategoriesByGuestDiscountSuccess(response.data.data));
        } else {
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
            yield put(getCategoriesByGuestDiscountError(response.data.message));
        }
    } catch (error) {
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
        yield put(getCategoriesByGuestDiscountError(error.response.data.message));
    }
}